var _g, _path, _g2, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 269,
    height: 268,
    viewBox: "0 0 269 268",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2069_15096)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2069_15096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.5 241C196.08 241 246 191.08 246 129.5C246 67.9202 196.08 18 134.5 18C72.9202 18 23 67.9202 23 129.5C23 191.08 72.9202 241 134.5 241Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 129.5C243 189.423 194.423 238 134.5 238C74.5771 238 26 189.423 26 129.5C26 69.5771 74.5771 21 134.5 21C194.423 21 243 69.5771 243 129.5Z",
    stroke: "#E9E9E9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2069_15096",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 76,
    y: 64,
    width: 118,
    height: 118
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M193.981 64H76V181.981H193.981V64Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2069_15096)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M163.668 193.335C158.391 193.335 153.905 191.488 150.21 187.793C146.516 184.099 144.668 179.613 144.668 174.335C144.668 173.702 144.827 172.224 145.143 169.902L100.652 143.935C98.9629 145.518 97.0101 146.76 94.7935 147.659C92.5768 148.558 90.2018 149.006 87.6685 149.002C82.3907 149.002 77.9046 147.155 74.2101 143.46C70.5157 139.766 68.6685 135.28 68.6685 130.002C68.6685 124.724 70.5157 120.238 74.2101 116.543C77.9046 112.849 82.3907 111.002 87.6685 111.002C90.2018 111.002 92.5768 111.451 94.7935 112.351C97.0101 113.25 98.9629 114.489 100.652 116.068L145.143 90.1018C144.932 89.3629 144.801 88.6515 144.751 87.9675C144.7 87.2835 144.673 86.5171 144.668 85.6685C144.668 80.3907 146.516 75.9046 150.21 72.2101C153.905 68.5157 158.391 66.6685 163.668 66.6685C168.946 66.6685 173.432 68.5157 177.127 72.2101C180.821 75.9046 182.668 80.3907 182.668 85.6685C182.668 90.9462 180.821 95.4323 177.127 99.1268C173.432 102.821 168.946 104.668 163.668 104.668C161.135 104.668 158.76 104.219 156.543 103.319C154.327 102.42 152.374 101.181 150.685 99.6018L106.193 125.568C106.405 126.307 106.538 127.021 106.592 127.709C106.647 128.397 106.673 129.162 106.668 130.002C106.664 130.842 106.639 131.608 106.592 132.301C106.546 132.993 106.413 133.705 106.193 134.435L150.685 160.402C152.374 158.818 154.327 157.579 156.543 156.684C158.76 155.789 161.135 155.339 163.668 155.335C168.946 155.335 173.432 157.182 177.127 160.877C180.821 164.571 182.668 169.057 182.668 174.335C182.668 179.613 180.821 184.099 177.127 187.793C173.432 191.488 168.946 193.335 163.668 193.335Z",
    fill: "#1E1E1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2069_15096",
    x: 0.700001,
    y: 0.160001,
    width: 267.6,
    height: 267.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.46
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2069_15096"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2069_15096",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2069_15096"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 269,
    height: 268,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.6dc7f978415a73dfe6fc01283814a48a.svg";
export { ForwardRef as ReactComponent };